import { RequestAction, createRequestActionCreators, createPayloadAction } from 'helpers/actionsHelpers'
import { PayloadAction } from 'interfaces/action'
import { RecaptchaPlacement, RecaptchaWidgetID, RecaptchaCallback } from 'interfaces/recaptcha'

export const LOAD_RECAPTCHA_API = 'LOAD_RECAPTCHA_API' as const
export type LoadRecaptchaAPI = RequestAction<typeof LOAD_RECAPTCHA_API, {}, {}>
export const loadRecaptchaAPIActionCreator = createRequestActionCreators<typeof LOAD_RECAPTCHA_API, {}, {}>(LOAD_RECAPTCHA_API)

export type RegisterRecaptchaWidgetPayload = {
  placement: RecaptchaPlacement
  widgetID: RecaptchaWidgetID
  callback: RecaptchaCallback
}
export const REGISTER_RECAPTCHA_WIDGET = 'REGISTER_RECAPTCHA_WIDGET' as const
export type RegisterRecaptchaWidget = PayloadAction<typeof REGISTER_RECAPTCHA_WIDGET, RegisterRecaptchaWidgetPayload>
export const registerRecaptchaWidgetActionCreator = (payload: RegisterRecaptchaWidgetPayload) =>
  createPayloadAction(REGISTER_RECAPTCHA_WIDGET, payload)

type RecaptchaPlacementPayload = { placement: RecaptchaPlacement }
export const UNREGISTER_RECAPTCHA_WIDGET = 'UNREGISTER_RECAPTCHA_WIDGET' as const
export type UnregisterRecaptchaWidget = PayloadAction<typeof UNREGISTER_RECAPTCHA_WIDGET, RecaptchaPlacementPayload>
export const unregisterRecaptchaWidgetActionCreator = (payload: RecaptchaPlacementPayload) =>
  createPayloadAction(UNREGISTER_RECAPTCHA_WIDGET, payload)

export const EXECUTE_RECAPTCHA = 'EXECUTE_RECAPTCHA' as const
export type ExecuteRecaptcha = PayloadAction<typeof EXECUTE_RECAPTCHA, { placement: RecaptchaPlacement }>
export const executeRecaptchaActionCreator = (placement: RecaptchaPlacement) =>
  createPayloadAction(EXECUTE_RECAPTCHA, { placement })

export const RECAPTCHA_EXECUTED = 'RECAPTCHA_EXECUTED' as const
type RecaptchaExecuted = PayloadAction<typeof RECAPTCHA_EXECUTED, RecaptchaPlacement>
export const recaptchaExecutedActionCreator = (placement: RecaptchaPlacement): RecaptchaExecuted =>
  createPayloadAction(RECAPTCHA_EXECUTED, placement)

export const RECAPTCHA_FAILED = 'RECAPTCHA_FAILED' as const
type RecaptchaFailed = PayloadAction<typeof RECAPTCHA_FAILED, RecaptchaPlacement>
export const recaptchaFailedActionCreator = (placement: RecaptchaPlacement): RecaptchaFailed =>
  createPayloadAction(RECAPTCHA_FAILED, placement)

export type RecaptchaActions =
  | LoadRecaptchaAPI
  | RegisterRecaptchaWidget
  | UnregisterRecaptchaWidget
  | ExecuteRecaptcha
  | RecaptchaExecuted
  | RecaptchaFailed

export default RecaptchaActions
